module.exports = require("he");